import { TaskListResponse, TasksRequest, TaskV2, UserTask, UserTasksListResponse } from '../types';
import { createRequestConfig, medtechApi } from './index';

function mapTaskToUserTask(task: TaskV2): UserTask {
  const attrs = task.attributes;

  return {
    id: task.id,
    status: attrs.status,
    title: attrs.title,
    description: attrs.description,
    owner: attrs.owner_full_name, // mapping owner_full_name to owner
    owner_id: attrs.owner_id,
    creator: attrs.creator_full_name, // mapping creator_full_name to creator
    creator_id: attrs.creator_id,
    created_at: attrs.created_at,
    updated_at: attrs.updated_at,
    closed_at: attrs.closed_at,
    time_limit: attrs.time_limit,
    due_date: attrs.due_date,
    type: task.type,
    related_to_id: attrs.issue_id, // assuming related_to_id maps to issue_id
    related_to_url: attrs.issue_code, // assuming related_to_url maps to issue_code (you might want to format this)
  };
}

function mapResponse(apiResponse: TaskListResponse): UserTasksListResponse {
  return {
    items: apiResponse.data.map(mapTaskToUserTask),
    total: apiResponse.meta.totalItems,
  };
}

const tasksApi = {
  async getAllTasks(company: number, filterParams?: TasksRequest): Promise<TaskListResponse | undefined> {
    const res = await medtechApi.get(
      `/quality-events/${company}/tasks`,
      createRequestConfig({
        params: filterParams,
      }),
    );
    return TaskListResponse.parse(res.data);
  },
  async getAllTasksMappedToUserTaskResponse(
    company: number,
    filterParams?: TasksRequest,
  ): Promise<UserTasksListResponse | undefined> {
    const res = await medtechApi.get(
      `/quality-events/${company}/tasks`,
      createRequestConfig({
        params: filterParams,
      }),
    );
    const tasksResponse = TaskListResponse.parse(res.data);
    return mapResponse(tasksResponse);
  },
};

export default tasksApi;
